import React, { useState } from "react";

import { SearchIcon } from "components/Icons";
import { classNames } from "tools/ui";

const style =
  "flex my-auto shadow-md rounded-full py-3 px-4 mx-auto text-neutral-800 focus-within:border focus-within:border-cyan-500";

function SearchBar(props) {
  const { name, handleSearch, color, autoSearch, size } = props;
  const [placeholder, setPlaceholder] = useState(null);
  const [textSearch, setTextSearch] = useState("");

  const _color = color ?? "bg-neutral-100";

  function onChange(event) {
    const val = event.target.value;
    setTextSearch(val);
    if (autoSearch) {
      handleSearch(val);
    }
  }

  function searchAction(event) {
    const _event = event.nativeEvent;
    // keyCode = 13 is Enter
    if (event.keyCode === 13 || (_event && _event.type === "click")) {
      handleSearch(textSearch);
    }
  }

  return (
    <div id="search-bar" className={classNames(style, _color, size)}>
      <input
        type="text"
        name={name}
        key={name}
        value={textSearch}
        placeholder="Buscar..."
        onChange={onChange}
        onKeyDown={searchAction}
        className="w-full ml-1 placeholder-opacity-50 text-md placeholder:text-lg focus:border-none focus:outline-none"
      />
      <SearchIcon
        onClick={searchAction}
        className="m-auto h-6 w-6 fill-current text-neutral-500 active:text-sky-600 cursor-pointer active:scale-90 hover:text-blue-700"
        aria-hidden="true"
      />
    </div>
  );
}

export default SearchBar;
